








































































































































































































import { stripeState, userState } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { config } from '@/config';
import BillingAddressModal from '@/components/modals/BillingAddressModal.vue';

@Component({
  components: { BillingAddressModal },
  filters: {
    formatIbanLast4: function(value: string): string {
      if (!value) return '';
      value = value.toString();
      return value.substring(0, 2) + ' ' + value.substring(2);
    },
  },
})
export default class ConfirmPage extends Vue {
  public models = {
    tosAccepted: false,
    privacyPolicyAccepted: false,
  };

  public get isAddressIncomplete() {
    return (
      !this.organization.title ||
      !userState.organization.title ||
      !userState.organization.addressStreet ||
      !userState.organization.addressStreetNumber ||
      !userState.organization.addressZipCode ||
      !userState.organization.addressCity ||
      !userState.organization.addressCountry
    );
  }

  public get selectedPlan() {
    return stripeState.plans.find(
      plan => plan.id === stripeState.selectedPlanId,
    );
  }

  public get selectedCreditCard() {
    return stripeState.cards.find(
      card => card.id === stripeState.selectedCardId,
    );
  }

  public get selectedSepaDirectDebit() {
    return stripeState.sepaDirectDebits.find(
      sepaDirectDebit =>
        sepaDirectDebit.id === stripeState.selectedSepaDirectDebitId,
    );
  }

  public get organization() {
    return userState.organization;
  }

  public get buttonEnabled() {
    return (
      this.models.tosAccepted &&
      this.models.privacyPolicyAccepted &&
      stripeState.selectedPlanId &&
      (stripeState.selectedCardId || stripeState.selectedSepaDirectDebitId) &&
      !this.isAddressIncomplete
    );
  }

  public get paymentMethodId(): string {
    if (userState.organization.paymentMethod === 'CREDIT_CARD') {
      return stripeState.selectedCardId;
    }

    return stripeState.selectedSepaDirectDebitId;
  }

  public created() {
    document.title = `${this.$t(this.$route.meta.title)} | Comply`;
    if (!stripeState.selectedPlanId) {
      return this.$router.push('/');
    }

    if (userState.organization.paymentMethod === 'CREDIT_CARD') {
      if (!stripeState.selectedCardId) {
        if (stripeState.cards && stripeState.cards[0]) {
          return this.$router.push('/payment-method/select/credit-card');
        } else {
          return this.$router.push('/payment-method/create/credit-card');
        }
      }
    } else if (userState.organization.paymentMethod === 'SEPA_DIRECT_DEBIT') {
      if (!stripeState.selectedSepaDirectDebitId) {
        if (stripeState.sepaDirectDebits && stripeState.sepaDirectDebits[0]) {
          return this.$router.push('/payment-method/select/sepa-direct-debit');
        } else {
          return this.$router.push('/payment-method/create/sepa-direct-debit');
        }
      }
    }
  }

  public async createSubscriptionSchedule() {
    try {
      const subscriptionSchedule = await this.$api.createSubscriptionSchedule({
        priceId: stripeState.selectedPlanId,
        paymentMethodId: this.paymentMethodId,
      });
      window.location.replace(config.complyAppURL);
    } catch (error) {
      console.log(error);
    }
  }
}
